<template>
	<div class="container">
		<div class="form__wrapper">
			<div class="form__title">
				Reset your password
			</div>
			<div class="form__body form__body--sm">
				<div v-if="getErrorMessage" class="alert alert-danger" role="alert">
					{{getErrorMessage}}
				</div>
				<template v-if="!passwordReset">
					<div class="form__text">
						<p>Enter your username, or the email address that you you used to register. We’ll send you an email with your username and a limk to reset your password.</p>
					</div>
					<form @submit.prevent="reset">
						<div class="form-row">
							<div class="col-md-12">
								<div class="form-group">
									<label for="email">Email Address</label>
									<input
										id="email" 
										class="form-control" 
										placeholder="Email Address" 
										type="email"
										v-model="itemData.email"
										:class="[{'is-invalid': errors.email}]"
										@keydown="clearErrors($event.target.name)">
									<div class="invalid-feedback">
										{{ errors.email }}
									</div>
								</div>
							</div>
						</div>

						<div class="btn__group btn__group--form">
							<button
								v-bind="{'disabled': loading}"
								@click.prevent="reset" 
								type=submit 
								class="btn__primary btn__primary--main">Reset Password</button>
						</div>
					</form>
					<div class="form__meta">
						<p>Don't have an account? 
							<router-link
								:to="{name: 'login'}" 
								class="form__link" exact>Sign In</router-link>
						</p>
					</div>
				</template>
				<template v-else>
					<div class="form__text form__text--lg">
						<h4>Your password has been successfully reset! <br> An email has been sent to you.</h4>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import form from '../mixins/form';
import auth from '../utils/validations/auth';

export default {
	name: 'ForgotPassword',
	mixins: [form],
	data() {
		return {
			itemData: {
				email: ''
			},
			loading: false,
			errors: {},
			passwordReset: false
		};
	},
	computed: {
		...mapGetters([
			'getStatus',
			'getErrorMessage'
		])
	},
	watch: {
		getStatus(value) {
			if (value === 'error') {
				this.loading = false;
			}
			if (value === 'success') {
				this.loading = false;
				this.passwordReset = true;
			}
		}
	},
	methods: {
		...mapActions([
			'resetPassword'
		]),
		reset() {
			this.validate(this.itemData, auth.reset);
			if (Object.keys(this.issues).length) {
				this.errors = this.issues;
				return false;
			}
			this.loading = true;
			this.resetPassword(this.itemData);
			return true;
		}
	}
};
</script>

<style lang="scss" scoped>
.btn__group--form {
	margin-top: 30px;
	text-align: center;
}
.btn__primary--main {
	width: 230px;
}
.form__text {
	color: $grey;
}
</style>
